import { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconCircle } from '#src/atoms/icons/system/iconCircle.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  count: number;
  size: 'small' | 'medium';
  color?: Color;
};

const Dot = styled(FontAwesomeIcon)<{
  $size: Props['size'];
}>`
  vertical-align: middle;
  ${({ $size }) =>
    $size === 'small'
      ? css`
          width: 6px !important;
          height: 4px;
        `
      : css`
          width: 15px !important;
          height: 10px;
        `}
`;

export const Dots = ({ count, size, color }: Props) => {
  const arr = useMemo(
    () => new Array(count).fill(null).map((_, i) => i + 1),
    [count]
  );
  return (
    <>
      {arr.map(index => (
        <Dot key={index} icon={iconCircle} $size={size} color={color} />
      ))}
    </>
  );
};
